const SIDEBAR_STORAGE_KEY = "sidebar_state"

export const getSidebarStateFromStorage = (): boolean => {
  if (typeof window === "undefined") return true

  try {
    const stored = localStorage.getItem(SIDEBAR_STORAGE_KEY)
    return stored !== null ? JSON.parse(stored) : true
  } catch (error) {
    console.warn(
      "Failed to read sidebar state from localStorage:",
      error
    )
    return true
  }
}

export const setSidebarStateInStorage = (
  open: boolean
): void => {
  if (typeof window === "undefined") return

  try {
    localStorage.setItem(
      SIDEBAR_STORAGE_KEY,
      JSON.stringify(open)
    )
  } catch (error) {
    console.warn(
      "Failed to save sidebar state to localStorage:",
      error
    )
  }
}

export const clearSidebarStateFromStorage = (): void => {
  if (typeof window === "undefined") return

  try {
    localStorage.removeItem(SIDEBAR_STORAGE_KEY)
  } catch (error) {
    console.warn(
      "Failed to clear sidebar state from localStorage:",
      error
    )
  }
}

export const handleToggleSidebar = (
  isMobile: boolean,
  toggleSidebar: () => void
) => {
  if (isMobile) {
    toggleSidebar()
  }
}

const PARENT_PATHS_WITH_CHILDREN = ["/report-delivery"]

export const isLinkActive = (
  href: string,
  mainPath: string,
  pathname: string
): boolean => {
  if (href === pathname) return true
  if (mainPath === "/portal") return pathname === "/portal"

  const normalizedPathname = pathname.replace(/^\/portal/, "")

  if (PARENT_PATHS_WITH_CHILDREN.includes(mainPath)) {
    return normalizedPathname === mainPath
  }

  return (
    normalizedPathname === mainPath ||
    normalizedPathname.startsWith(mainPath + "/") ||
    normalizedPathname.startsWith(mainPath + "?")
  )
}
